import { ReactNode, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Loader from '../components/common/loader/Loader';
import { LINKS } from './Links';

interface RouteConfig {
  path: string;
  element: ReactNode;
  protected?: boolean;
}

export const AppRouter = ({ routes }: { routes: RouteConfig[] }) => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {routes.map(({ path, element }, index) => (
          <Route key={index} path={path} element={element} />
        ))}
        <Route
          path='*'
          element={<Navigate to={LINKS.HOME.build()} replace />}
        />
      </Routes>
    </Suspense>
  );
};
